export const DEFAULT_ERROR_MESSAGE = "Chyba při komunikaci se serverem.";
